import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    timepointId: String
  };

  static targets = ["addStepOptions", "stepsSortable", "resetConfirmation"]

  stepsSortableTargetConnected(){
    this.initializeSortLogic()
  }

  initializeSortLogic(){
    if ($(this.stepsSortableTarget).length > 0) {
      $(this.stepsSortableTarget).sortable({
        axis: "y",
        items: ".item",
        cursor: "move",
        handle: ".fa-grip-vertical",
        sort: function (e, ui) {
          return ui.item.addClass("active-item-shadow");
        },
        stop: function (e, ui) {
          ui.item.removeClass("active-item-shadow");
          return ui.item.children("td").effect("highlight", {}, 1000);
        },
        update: () => {
          $(this.stepsSortableTarget).find(".step-card").each( index => {
              var step_card = $($(this.stepsSortableTarget).find(".step-card")[index])
              var step_card_id = `step_card_${index}`

              // change id of card to new index:
              step_card.attr("id", step_card_id)
              step_card = $(`#${step_card_id}`)
              
              // change id of various inputs on card to new index: 
              step_card.find('[name*="step_label"]').attr("name", `step_label_${index}`)
              step_card.find('[name*="step_type"]').attr("name", `step_type_${index}`)
              step_card.find('[name*="step_requirements"]').attr("name", `step_requirements_${index}`)
              step_card.find('[name*="instructions"]').attr("name", `instructions_${index}`)
              step_card.find('[name*="step_id"]').attr("name", `step_id_${index}`)
              step_card.find('.remove-step-link').attr("target", index)
          })
        },
      });
    }
  }

  updateTimepointStepTurboFrame(event) {
    var data = {}
    var stepData = [];

    $(this.stepsSortableTarget).find('.step-card').each((index,step) => {
      var current_step = {}
      current_step["index"] = index
      current_step["step_label"] = $(step).find(`input[name='step_label_${index}']`)[0].value
      current_step["instructions"] = $(step).find(`input[name='instructions_${index}']`)[0].value
      current_step["step_type"] = $(step).find(`input[name='step_type_${index}']`)[0].value
      current_step["step_requirements"] = $(step).find(`select[name='step_requirements_${index}']`)[0].value
      current_step["step_id"] = $(step).find(`input[name='step_id_${index}']`)[0].value

      stepData.push(current_step);
    });
    data['stepData'] = stepData
    data['action'] = $(event.target)[0].getAttribute("action")
    data['target'] = $(event.target)[0].getAttribute("target")
    data['default_step'] = $(event.target)[0].getAttribute("default-step")
    data['new_step_type'] = $(event.target)[0].getAttribute("new-step-type")

    $('#sample_timepoint_step_data_for_turbo')[0].value = JSON.stringify(data)
    $("#sample-timepoint-step-turbo-form")[0].requestSubmit();
  }

  validateStepOrder(event){
    event.preventDefault()
    
    let step_number = 0
    let step = document.getElementsByName(`step_type_${step_number}`)[0]
    let steps = {}
    while (step != undefined) {
      steps[step.value] = step_number
      step_number++
      step = document.getElementsByName(`step_type_${step_number}`)[0]
    }
    if (
      steps["collection"] > steps["aliquot"] || 
      steps["storage"] < steps["aliquot"] ||
      (steps["meta_fields"] != undefined && steps["aliquot"] < steps["meta_fields"]) || 
      (steps["kit_registration"] != undefined && (steps["collection"] > steps["kit_registration"] || steps["kit_registration"] > steps["aliquot"]))  || (steps["consent"] != undefined && steps["consent"] > steps["collection"])
      ) {
        document.getElementById("order_error").classList.remove("d-none")
    } else {
      document.getElementById("order_error").classList.add("d-none")
      document.getElementById("timepoint_step_form").requestSubmit()
    }
  }

  toggleAddStepOptions(event){
    event.preventDefault()
    this.addStepOptionsTarget.classList.toggle("d-none")
  }

  hideErrorMessage(event){
    event.preventDefault()
    document.getElementById("error_message").classList.add("d-none")
  }

  toggleResetConfirmation(event){
    event.preventDefault()
    this.resetConfirmationTarget.classList.toggle("d-none")
  }
}
